import { render, staticRenderFns } from "./TwismWalletDetail.vue?vue&type=template&id=858b10e6&scoped=true&"
import script from "./TwismWalletDetail.vue?vue&type=script&lang=ts&"
export * from "./TwismWalletDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWalletDetail.vue?vue&type=style&index=0&id=858b10e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858b10e6",
  null
  
)

export default component.exports